import React from 'react';
import { FuelRadio, FuelTypography } from '@frete.com/fuel-react';
import { LogoContainer, PartnerContainer, Wrapper } from './styled';
import { Props } from './types';

export const PartnerSelect: React.FC<Props> = ({ onClick, value, price, checked, image, disabled, free }) => {
  const handleClick = () => {
    if (disabled) return;
    onClick(value);
  };

  return (
    <Wrapper onClick={handleClick} $checked={checked} $disabled={disabled}>
      <FuelRadio disabled={disabled} checked={checked} value={value} />
      <PartnerContainer>
        <LogoContainer>
          <img src={image} alt="GR Parceira" />
        </LogoContainer>
        <FuelTypography
          size="caption"
          weight="bold"
          color={!checked || free ? 'neutral-weak' : 'neutral-strong'}
          style={{ textDecoration: free ? 'line-through' : 'none' }}
        >
          {`${price} POR CADASTRO`}
        </FuelTypography>
      </PartnerContainer>
    </Wrapper>
  );
};
